<template>
  <div class="slider-controls">
    <WhiteButton class="slider-controls__button slider-controls__button--prev"
      :class="buttonClasses"
      :is-disabled="disablePrev"
      @click="$emit('prev')"
      aria-label="Previous slide">
      Попередній слайд
    </WhiteButton>

    <WhiteButton class="slider-controls__button slider-controls__button--next"
      :class="buttonClasses"
      :is-disabled="disableNext"
      @click="$emit('next')"
      aria-label="Next slide">
      Наступний слайд
    </WhiteButton>
  </div>
</template>

<script>
import { WhiteButton } from '@/shared/ui/form';

export default {
  props: {
    orientation: {
      type: String,
      default: 'horizontal',
      validator: (value) => ['horizontal', 'vertical'].includes(value)
    },
    disablePrev: {
      type: Boolean,
      default: false,
    },
    disableNext: {
      type: Boolean,
      default: false,
    },
  },
  components: { WhiteButton },
  computed: {
    buttonClasses() {
      return {
        'slider-controls__button--horizontal': this.orientation === 'horizontal',
        'slider-controls__button--vertical': this.orientation === 'vertical'
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.slider-controls {
  position: absolute;
  display: flex;
  justify-content: space-between;
  left: 24px;
  right: 24px;
  bottom: 24px;
  z-index: 9;

  @media (max-width: 450px) {
    flex-direction: column;
  }

  &__button {
    transition: background-color 300ms ease-in-out;

    @media (max-width: 450px) {
      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }
  }
}
</style>
